const WORKSPACE_KEY = "puckly-coach-workspace-key-v1";

export function getWorkspaceKey(
  storage: Pick<Storage, "getItem" | "setItem"> = localStorage,
) {
  const saved = storage.getItem(WORKSPACE_KEY);
  if (saved && /^[a-f0-9]{64}$/.test(saved)) return saved;
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const generated = [...bytes]
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
  storage.setItem(WORKSPACE_KEY, generated);
  return generated;
}

export function setWorkspaceKey(
  key: string,
  storage: Pick<Storage, "setItem"> = localStorage,
) {
  const normalized = key.trim().toLowerCase();
  if (!/^[a-f0-9]{64}$/.test(normalized)) return false;
  storage.setItem(WORKSPACE_KEY, normalized);
  return true;
}
